import { FieldStub } from "./_FieldStub";
import type { FieldPrimitiveProps } from "./types";

// STUB — CHG-1167 scaffold. Real impl lands ε CHG-1156 (templates).
// Contract: specs/_product/field-primitive-registry.md §1 ('rich_text').
// Doctrine: feedback_field_primitive_components_canonical.md.

export function RichTextField(props: FieldPrimitiveProps<string>) {
  return <FieldStub {...props} fieldType="rich_text" inputType="text" />;
}
